import React from 'react'
import { useParams } from 'react-router-dom'

import {
  useBeneficiaryRecapQuery,
  useCustodianRecapQuery,
  usePublicRecapQuery,
} from 'generated/types'

import { useSmartDeposit } from './hooks/useSmartDeposit'
import { PublishingPage } from './PublishingPage'

export const RecapPage = (): React.ReactElement => {
  const { beneficiaryId, publicToken } = useParams<{
    beneficiaryId?: string
    publicToken?: string
  }>()

  const isCustodian = Boolean(beneficiaryId)

  const {
    data: beneficiaryData,
    loading: recapIdLoading,
    error: recapIdError,
  } = useBeneficiaryRecapQuery({
    skip: !isCustodian,
    variables: {
      id: beneficiaryId || '',
    },
  })

  const recapId =
    beneficiaryData?.beneficiary?.investmentAccount?.quarterlyRecap?.id || ''

  const {
    data: custodianData,
    loading: custodianLoading,
    error: custodianError,
  } = useCustodianRecapQuery({
    skip: !isCustodian || !recapId,
    variables: {
      id: recapId,
    },
  })

  const {
    data: publicData,
    loading: publicLoading,
    error: publicError,
  } = usePublicRecapQuery({
    skip: isCustodian,
    variables: {
      id: publicToken || '',
    },
  })

  const data = isCustodian
    ? custodianData?.investmentAccountRecap
    : publicData?.investmentAccountRecapByPublicToken

  const loading = isCustodian
    ? recapIdLoading || custodianLoading
    : publicLoading
  const error = isCustodian ? recapIdError || custodianError : publicError

  const investmentAccountId = isCustodian
    ? beneficiaryData?.beneficiary?.investmentAccount?.id
    : undefined

  const smartDepositAmount = useSmartDeposit(investmentAccountId)

  return (
    <PublishingPage
      data={data}
      loading={loading}
      error={error}
      isCustodian={isCustodian}
      smartDepositAmount={smartDepositAmount}
    />
  )
}
